import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import {
  Container,
  Typography,
  Divider,
  Card,
  CardContent,
  CardActions,
  Stack,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
import useResponsive from '../hooks/useResponsive';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Services from 'src/services/Services';
import { toast } from 'react-toastify';

// Sol bölge – LoginPage'deki sol panel ile aynı
const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows?.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

function InvoicePaymentCard({ navigate }) {
  const [invoice, setInvoice] = useState('');
  const [tax, setTax] = useState('');
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);

  const checkInvoice = async () => {
    setLoading(true);
    try {
      console.log(invoice, tax);
      const res = await Services.GetInvoiceDetail(token, invoice, tax);
      console.log(res.data);
      if (!res.data.status) {
        toast.error(
          res.data.message === 'Invoice not found'
            ? 'Fatura bulunamadı'
            : 'Fatura bilgisi çekilemedi.'
        );
        return;
      }

      const item = res.data.result;

      if (item.isPaid) {
        navigate('/paid-bill', { state: { item } });
      } else {
        navigate('/payment-bill', { state: { invoice, tax, token, item } });
      }
    } catch (err) {
      console.error(err);
      toast.error('Fatura bilgisi çekilemedi.');
    } finally {
      setLoading(false);
    }
  };

  function getToken() {
    Services.GetMLToken().then((res) => {
      console.log(res.data.result);
      if (res.data.status) setToken(res.data.result.token);
    });
  }

  useEffect(() => {
    getToken();
  }, []);

  return (
    <Card>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          Fatura Ödeme
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Stack spacing={3}>
          <TextField
            required
            fullWidth
            label="Fatura No"
            name="invoiceNumber"
            variant="outlined"
            value={invoice}
            onChange={(e) => setInvoice(e.target.value)}
          />
          <TextField
            required
            fullWidth
            label="VKN veya TCKN"
            name="taxNumber"
            variant="outlined"
            value={tax}
            onChange={(e) => setTax(e.target.value)}
          />
        </Stack>
      </CardContent>
      <CardActions sx={{ p: 2 }}>
        <Button
          fullWidth
          variant="contained"
          size="large"
          loading={loading}
          disabled={loading || invoice.length < 3 || tax.length < 3}
          onClick={checkInvoice}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'İşleme Devam Et'
          )}
        </Button>
      </CardActions>
    </Card>
  );
}

// Yeni Fatura Ödeme sayfası
export default function PayBill() {
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title> Fatura Ödeme | Mall Logistics Panel </title>
      </Helmet>

      <StyledRoot>
        {mdUp && (
          <StyledSection>
            <div
              style={{
                backgroundColor: '#103996',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <img src="/assets/logo.png" alt="Logo" />
            </div>
            <img src="/assets/illustrations/login-ill.png" alt="illustration" />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <InvoicePaymentCard navigate={navigate} />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
